import api from "@/api/axiosConfig.js";
import { handleSuccessResponse, handleErrorResponse } from '@/api/apiUtils.js';

const MODULE_NAME = 'BackupsAPI';

export const backupsAPI = {
  getAll: async (showNotification = false) => {
    try {
      const response = await api.get('/backups');
      return handleSuccessResponse(response, MODULE_NAME, 'Получение бэкапов', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получении бэкапов');
    }
  },

  getByProject: async (projectUUID, showNotification = false) => {
    try {
      const response = await api.get(`/projects/${projectUUID}/backups`);
      return handleSuccessResponse(response, MODULE_NAME, 'Получение бэкапов проекта', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получении бэкапов проекта');
    }
  },

  delete: async (projectUUID, backupId, showNotification = true) => {
    try {
      const response = await api.delete(`/projects/${projectUUID}/backups/${backupId}`);
      return handleSuccessResponse(response, MODULE_NAME, 'Удаление бэкапа', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'удалении бэкапа');
    }
  },

  getUploads: async () => {
    try {
      const response = await api.get('/backups/uploads');
      return handleSuccessResponse(response, MODULE_NAME, 'Получение загрузок', false);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получении загрузок', false);
    }
  },

  abortUpload: async (uploadId, showNotification = true) => {
    try {
      const response = await api.delete(`/backups/uploads/${uploadId}`);
      return handleSuccessResponse(response, MODULE_NAME, 'Отмена загрузки', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'отмене загрузки');
    }
  },

  // Скачивание идёт обычной навигацией (файл до десятков ГБ — через axios/blob не годится), cookie уходит сама
  downloadUrl: (projectUUID, backupId) =>
    `${api.defaults.baseURL}/projects/${projectUUID}/backups/${backupId}/download`,
};
